import VueRouter from 'vue-router';
import AbstractFilter from '../AbstractFilter';
import SelectFieldComponent from '@/components/forms/fields/common/SelectField.vue';
import Option from '@/zenky/forms/interfaces/FormFieldOption';
import store from '@/store/index';

export default class CityFilter extends AbstractFilter {
  readonly name = 'city_id';
  readonly label: string = 'Город';
  async init() {
    if (store.state.helpers.storeCities === null) {
      return store.dispatch('helpers/loadStoreCities');
    }
  };
  readonly component = SelectFieldComponent;
  get componentProps() {
    return {
      values: store.state.helpers.storeCities === null
        ? []
        : store.state.helpers.storeCities.map((city): Option => ({ label: city.name, value: city.id })),
      placeholder: this.label,
      allowEmpty: true,
    };
  }
  valueFromQuery(query: VueRouter['currentRoute']['query']): string | null {
    return query[this.name] === undefined ? null : query[this.name] as string;
  }
  queryArgFromValue(value: ReturnType<this['valueFromQuery']>) {
    return value;
  }
}
